import React from "react"
import SliderGraficiNazionali from "../../slider/SliderGraficiNazionali"

function TabGrafici(props: any) {
    return (
        <div id="tab-grafici">
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-12"> </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <SliderGraficiNazionali
                        datiNazionali={props.datiNazionali}
                        codIsa={props.codIsa}
                        macroarea={props.macroareasigla}
                        anno={props.anno}
                    />
                </div>
            </div>
        </div>
    )
}

export default TabGrafici
